import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	defaultValueTooLargeErrorNumber: {
		id: 'project-settings-apps.issue-type-page.field.field-configuration.number.default-value-too-large-error-number',
		defaultMessage: 'Can’t be larger than {MAX_ALLOWED_NUMBER}.',
		description:
			'Validation error shown to the user if too large number is typed in the input. {MAX_ALLOWED_NUMBER} is a placeholder for the largest allowed value.',
	},
});
